import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import { AuthService } from '../../services';
import { DxButtonModule, DxNumberBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { UIUtils } from '../../../services/uiutils.service';
import { ServerCommunicatorService } from '../../../services/server-communicator.service';
import { AppStateManageService } from '../../../services/app-state-manage.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';

const notificationText = 'We\'ve sent a link to reset your password. Check your inbox.';

@Component({
  selector: 'app-reset-password-form',
  templateUrl: './reset-password-form.component.html',
  styleUrls: ['./reset-password-form.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxButtonModule,
    DxTextBoxModule,
    DxNumberBoxModule,
  ],
})
export class ResetPasswordFormComponent {
  loading = false;
  formData: any = {email:"", password:"", confirmpassword:""};
  confirmpasswordMode = 'password';
  newpasswordMode = 'password';
  isResendOtpDisabled: boolean = false;
  ResendOtpTimer: number = 30; // Initial timer value
  otp: string  = '';
  isVerifyOtpDisabled: boolean = false;
  isOTPVerified: boolean = false;
  isVerifyPassword: boolean = false;
  constructor(private authService: AuthService, private router: Router, private uiUtils: UIUtils,private servercommunicator: ServerCommunicatorService,  private appStateManage: AppStateManageService,  public langService: LanguageService,
          private translate: TranslateService) { }

   ngOnInit() {
    this.startResendOtpTimer();     //Resend OTP Timer
  }
 
get isMr() {
  return this.langService.currentLang === 'mr';
}

async VerifyEmail ( e: Event) {
    let body = {
      email_id: this.formData.email,
    };
    const response = await this.servercommunicator.FetchRequestForForgotPassword(
      'generateuserotp',
      body
    );
    if (!response.successful) {
      await this.uiUtils.showErrorMessage('Error', response.message);
      return;
    } else {
      await this.uiUtils.showSuccessToster(
        'Please Check Your Mail, OTP Send On Your Email Id'
      );
      // this.appStateManage.setIsForgetPasswordClickedValue(true);
      // await this.router.navigate(['/forgot_password']);
    }
  };



  isDisableInput: boolean = false;

 VerifyOTP = async () => {
    let body = {
      email_id : this.formData.email,
      otp: this.otp
    }
    if (this.otp == '') {
      await this.uiUtils.showErrorMessage('', 'Enter OTP');
      return
    }
    this.isVerifyOtpDisabled = true;
    // ---------------------using new mqtt service --------------------
    const response = await this.servercommunicator.VerifyOTP(
      'verifyuserotp',
      body
    );
    if (!response.successful) {
      await this.uiUtils.showErrorMessage('Error', response.message);
      this.isVerifyOtpDisabled = false;
      this.isOTPVerified = false;
      return
    }
    else {
      this.isVerifyOtpDisabled = true;
      this.isOTPVerified = true;
      this.isDisableInput = false;
      await this.uiUtils.showSuccessToster('OTP Verified Successfuly');
    }
  }

 ResendOtp = async () => {
    if (this.isResendOtpDisabled) return
    this.otp = '';
    let body = {
      email_id : this.formData.email,
    }
    this.isResendOtpDisabled = true;
    this.isVerifyOtpDisabled = false;
    // ---------------------using new mqtt service --------------------
    const response = await this.servercommunicator.FetchRequestForForgotPassword(
      'sendpasswordchangeemailotp',
      body
    );
    if (!response.successful) {
      this.isResendOtpDisabled = false;
      await this.uiUtils.showInformationalMessage('Error', response.message);
      return
    }
    else {
      this.isResendOtpDisabled = false;
      await this.uiUtils.showInformationalMessage('Successfull', 'Please Check Your Mail, Resend OTP Send on Your Email Id');
      this.startResendOtpTimer();
    }
  }


   VerifyPassword = async () => {
    if (this.formData.email == '') {
      await this.uiUtils.showErrorMessage('Information', 'E-mail Id not Specified');
      return
    }
    else if (this.otp == '') {
      await this.uiUtils.showErrorMessage('Information', 'OTP not Specified');
      return
    }
    else if (this.formData.Password == '') {
      await this.uiUtils.showErrorMessage('Information', 'Password not Specified');
      return
    }
    else if (this.formData.confirmpassword == '') {
      await this.uiUtils.showErrorMessage('Information', 'Confirm Password not Specified');
      return
    }
    else if (this.formData.Password != this.formData.confirmpassword) {
      await this.uiUtils.showErrorMessage('Information', 'Password & Confirm Password is not Same');
      return
    }
    let body = {
      email_id: this.formData.email,
      otp: this.otp,
      password: this.formData.password,
      confirm_password: this.formData.confirmpassword
    }
    this.isVerifyPassword = true;
    // ---------------------using new mqtt service --------------------
    const response = await this.servercommunicator.UpdatePassword(
      'updatepassword',
      body
    );
    
    if (!response.successful) {
      await this.uiUtils.showErrorMessage('Error', response.message);
      this.isVerifyPassword = false;

      return
    }
    else {
      this.isVerifyPassword = false;
      await this.uiUtils.showSuccessToster('Password Change Successfuly');
      await this.router.navigate(['login']);
    }
  }
  // async onSubmit(e: Event) {
  //   e.preventDefault();
  //   const { email } = this.formData;
  //   this.loading = true;

  //   const result = await this.authService.resetPassword(email);
  //   this.loading = false;

  //   if (result.isOk) {
  //     this.router.navigate(['/login-form']);
  //     notify(notificationText, 'success', 2500);
  //   } else {
  //     notify(result.message, 'error', 2000);
  //   }
  // }



  
  

  
  

  
  
  
  
  // Add your verification logic here
  
  VeriftOtp() {
   console.log("Verifying OTP:", this.otp); //demo
 }
//  Enter OTP-  Allow only digits (0–9) //
filterDigits(e: any) {
  const input = e.event.target as HTMLInputElement;
  const digitsOnly = input.value.replace(/\D/g, ''); // remove all non-digits
  this.otp = digitsOnly;
}

//  toogle for Password hide and show // 
 toggleNewPasswordVisibility = () => {
    this.newpasswordMode = this.newpasswordMode === 'text' ? 'password' : 'text';
  };
  toggleConfirmPasswordVisibility = () => {
    this.confirmpasswordMode = this.confirmpasswordMode === 'text' ? 'password' : 'text';
  };

//Resend OTP Timer Function //
   startResendOtpTimer = async () => {
    this.isResendOtpDisabled = true;
    this.ResendOtpTimer = 30; // Reset the timer

    const interval = setInterval(() => {
      this.ResendOtpTimer--;

      if (this.ResendOtpTimer <= 0) {
        clearInterval(interval); // Clear the interval when the timer ends
        this.isResendOtpDisabled = false; // Re-enable the link
      }
    }, 1000); // Decrement every second
  }

// Back to Login Route //
   BackToLogin = async () => {
    await this.router.navigate(['/login']);
  }
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxButtonModule,
    DxTextBoxModule,
    DxNumberBoxModule,
    ResetPasswordFormComponent,
  ],
  exports: [ResetPasswordFormComponent],
})
export class ResetPasswordFormModule { }
